import { Component } from '@angular/core';
import { Location } from '@angular/common';


@Component({
    selector: 'app-menu',
    templateUrl: './menu.html',
})
export class MenuComponent {
  constructor(public location: Location) {}

  getStyleLink(path: string): boolean {
    const locationPath = this.location.path();
    if (locationPath.startsWith('/trackeradmin')) { // 3 routes starting with /tracker
      return path.startsWith('/trackeradmin');
    } else if (locationPath.startsWith('/trackerstatus')) {
      return path.startsWith('/trackerstatus');
    } else if (locationPath.startsWith('/useradmin')) { // 2 routes starting with /user
      return path.startsWith('/useradmin');
    } else {
      return locationPath.startsWith(path);
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/core/menu/menu.component.ts